import React from 'react';
import { injectTestId } from '@cvent/nucleus-test-automation';
import useTheme from '@hooks/useTheme';

const useStyles = () => {
  const { backgroundColor, font } = useTheme();

  return {
    indicator: {
      color: font.color.danger.fill,
      height: 20,
      width: 20,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 'bold',
      fontSize: 11,
      marginLeft: 16,
      backgroundColor: backgroundColor.danger.fill.base,
      borderRadius: '50%'
    }
  };
};

/**
 * Simple badge that appears in nav link items. Shows counter text, or otherwise just renders circle indicator
 */
const NavItemIndicator = ({ text, testID }) => {
  const styles = useStyles({});
  return (
    <span css={styles.indicator} {...injectTestId(testID)}>
      {text}
    </span>
  );
};

export default NavItemIndicator;
